import { TypedClientApiError } from "@gosaas/api-client";
import { toast } from "sonner";

export interface ReportQueryErrorOptions {
	title?: string;
	/** When false, skip Sentry capture (expected API errors with user-facing copy). */
	capture?: boolean;
	/** When true, skip the toast (background polling that should fail quietly). */
	silent?: boolean;
}

export function reportQueryError(
	error: unknown,
	options?: ReportQueryErrorOptions,
): never {
	const message =
		error instanceof Error ? error.message : "An unexpected error occurred";

	if (!options?.silent) {
		toast.error(options?.title ?? "Something went wrong", {
			description: message,
		});
	}

	const shouldCapture =
		options?.capture ?? !(error instanceof TypedClientApiError);
	if (shouldCapture && typeof window !== "undefined") {
		void import("@sentry/react").then((Sentry) => {
			Sentry.captureException(error);
		});
	}

	throw error;
}

export function tagRequestId(requestId: string) {
	if (typeof window === "undefined") {
		return;
	}
	void import("@sentry/react").then((Sentry) => {
		Sentry.setTag("request_id", requestId);
	});
}
